export default __webpack_public_path__ + "static/media/lp-2-lqMAX.506e0c17.avif";